import React from "react";
import { Link } from "react-router-dom";
import "./FooterTop.scss";
import Logo1 from "../../../../assets/images/footer/icon/Visa.svg";
import Logo2 from "../../../../assets/images/footer/icon/Stripe.svg";
import Logo3 from "../../../../assets/images/footer/icon/PayPal.svg";
import Logo4 from "../../../../assets/images/footer/icon/UnionPay.svg";
import Logo5 from "../../../../assets/images/footer/icon/JCB.svg";
import Logo6 from "../../../../assets/images/footer/icon/Mastercard.svg";

function FooterTop() {
  return (
    <div className="footer-top">
      <div className="footer-top-list">
        <p className="footer-top-title">Về dibee</p>
        <div className="footer-top-content">
          <Link to="/article/introduce">Quy chế hoạt động</Link>
        </div>
        <div className="footer-top-content">
          <Link to="/article/support">Hướng dẫn mua hàng</Link>
        </div>
        <div className="footer-top-content">
          <Link to="/article/procedure">Quy trình đóng gói hàng hoá</Link>
        </div>
        <div className="footer-top-content">
          <Link to="/article/introduce">Giới thiệu dibee marketplace</Link>
        </div>
      </div>
      <div className="footer-top-list">
        <p className="footer-top-title">Chính sách & Quy định</p>
        <div className="footer-top-content">
          <Link to="/article/commodity">Chính sách hàng hóa</Link>
        </div>
        <div className="footer-top-content">
          <Link to="/article/policy">Chính sách đổi trả</Link>
        </div>
        <div className="footer-top-content">
          <Link to="/article/warranty">Bảo hành/Bảo trì sản phẩm</Link>
        </div>
        <div className="footer-top-content">
          <Link to="/article/security">Bảo vệ thông tin cá nhân</Link>
        </div>
        <div className="footer-top-content">
          <Link to="/article/website-management">Quản lý thông tin website</Link>
        </div>
        <div className="footer-top-content">
          <Link to="/article/complain">Giải quyết khiếu nại</Link>
        </div>
        <div className="footer-top-content">
          <Link to="/article/payments">Hình thức thanh toán</Link>
        </div>
      </div>
      <div className="footer-top-list">
        <p className="footer-top-title">Hỗ trợ khách hàng</p>
        <div className="footer-top-content">
          <span>Hotline: 028 3825 8912</span>
        </div>
        <div className="footer-top-content">
          <span>Email: cskh@dibee.co</span>
        </div>
        <div className="footer-top-content">
          <Link to="/article/support">Hướng dẫn mua hàng</Link>
        </div>
        <div className="footer-top-content">
          <Link to="/article/transport">Vận chuyển giao nhận</Link>
        </div>
        <div className="footer-top-content">
          <Link to="/article/policy">Đổi trả &amp; Hoàn tiền</Link>
        </div>
        <div className="footer-top-content">
          <Link to="/article/warranty">Bảo hành/Bảo trì sản phẩm</Link>
        </div>
        <div className="footer-top-content">
          <Link to="/article/complain">Giải quyết tranh chấp</Link>
        </div>
        <div className="footer-top-content">
          <Link to="/article/security">Bảo mật thông tin</Link>
        </div>
      </div>
      <div className="footer-top-list">
        <p className="footer-top-title">Phương thức thanh toán</p>
        <div className="footer-top-content">
          <span>Thanh toán khi nhận hàng (COD)</span>
        </div>
        <div className="footer-top-content">
          <span>Chuyển khoản ngân hàng</span>
        </div>
        <div className="footer-top-icon">
          <div className="footer-top-icon-ele">
            <Link to="/"><img src={Logo1} alt="Visa" /></Link>
          </div>
          <div className="footer-top-icon-ele">
            <Link to="/"><img src={Logo6} alt="Mastercard" /></Link>
          </div>
          <div className="footer-top-icon-ele">
            <Link to="/"><img src={Logo2} alt="Stripe" /></Link>
          </div>
          <div className="footer-top-icon-ele">
            <Link to="/"><img src={Logo3} alt="PayPal" /></Link>
          </div>
          <div className="footer-top-icon-ele">
            <Link to="/"><img src={Logo4} alt="UnionPay" /></Link>
          </div>
          <div className="footer-top-icon-ele">
            <Link to="/"><img src={Logo5} alt="JCB" /></Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FooterTop;
